/**
 * Used to obfuscate the fact we expose all the route names client side so the javascript can access it
 * Imported into entry.js and public-entry.js
 */

import routes from './../../../js/fos_js_routes';


